import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TRUE } from '../../../utils/config/const';

@Component({
  selector: 'app-draggable-list-chip',
  templateUrl: './draggable-list-chip.component.html',
  styleUrls: ['./draggable-list-chip.component.css']
})
export class DraggableListChipComponent implements OnInit {


  @Input() itemList:any[];
  @Input() labelKeys:any[];
  @Input() draggable: boolean = true;
  @Input() cancelSelectedIsEnabled: boolean = true;
  @Output() changeItemList = new EventEmitter<any>();

  private draggedIndex: number;
  public draggedOver: number;
  

  ngOnInit(): void {
    if(this.itemList == null || typeof this.itemList === typeof undefined){
      this.itemList = [];
    }
    if(this.labelKeys == null || typeof this.labelKeys === typeof undefined){
      this.labelKeys = [];
    }
  }

  onDragChipList(index): void {
    this.draggedIndex = index;
  }

  onDropChipList($event, index): void {
    $event.preventDefault();
    if(this.draggable === TRUE){
      const item = this.itemList[this.draggedIndex];
      this.itemList.splice(this.draggedIndex, 1);
      this.itemList.splice(index, 0, item);
      this.draggedIndex = -1;
      this.draggedOver = -1;
      this.changeItemList.emit(this.itemList);
    }
  }

  allowDropChipList($event, index): void {
    this.draggedOver = index;
    $event.preventDefault();
  }

  getLabel(item){
    let res = "";
    for (let obj of this.labelKeys) {
      res = res+" "+item[obj];
    }
    return res;
  }

  cancelSelected(id){
    if(this.cancelSelectedIsEnabled){
      //rimuove elemento dalla lista
      for(let i=0; i< this.itemList.length; i++){
        if(id === this.itemList[i].id){
          this.itemList.splice(i,1);
        }
      }
      this.changeItemList.emit(this.itemList);
    } 
  }

}
